import { render, staticRenderFns } from "./PlaylistView.vue?vue&type=template&id=bb280db0&"
import script from "./PlaylistView.vue?vue&type=script&lang=js&"
export * from "./PlaylistView.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports